import React from "react";
import { Box } from "@mui/material";
import Header from "./Header";
import { Outlet } from "react-router-dom";

const MainLayout: React.FC = () => {
  return (
    <Box display="flex" flexDirection="column" height="100vh">
      <Header />
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          overflow: "auto",
          padding: 0,
        }}
      >
        <Outlet />
      </Box>
    </Box>
  );
};

export default MainLayout;
